import React from 'react';
import RuleLink from '../components/RuleLink';

/**
 * Подтверждение удаления зоны.
 *
 * Два режима (FE-Z06):
 *  - `warning`    — предупреждение до запроса: зона может быть занята
 *    правилами (`used_by_rules`), но backend это ещё не подтвердил;
 *  - `dependency` — backend уже ответил 409 zone_used_by_active_rules и
 *    прислал точный список зависимых правил; следующий DELETE уйдёт с
 *    `force=true` и деактивирует их.
 */
const ZoneDeleteConfirmModal = ({
  zoneName,
  dependentRules = [],
  mode = 'warning',
  busy = false,
  error = '',
  onConfirm,
  onCancel,
}) => {
  const isDependency = mode === 'dependency';

  return (
    <>
      <div className="vio-modal-overlay" onClick={busy ? undefined : onCancel} />
      <div className="vio-modal" role="dialog" aria-label="Удаление зоны">
        <h3 className="vio-modal-title">
          {isDependency ? 'Зона используется активными правилами' : `Удалить зону «${zoneName}»?`}
        </h3>

        {dependentRules.length > 0 ? (
          <>
            <p className="vio-modal-text">Зона используется правилами:</p>
            <ul className="vio-modal-list">
              {dependentRules.map((rule) => (
                <li key={rule.rule_id}><RuleLink rule={rule} /></li>
              ))}
            </ul>
            <p className="vio-modal-text">
              {isDependency
                ? 'После удаления зоны эти правила будут деактивированы.'
                : 'Пока эти правила используют зону, удалить её нельзя. Сначала отключите или удалите правила.'}
            </p>
          </>
        ) : (
          <p className="vio-modal-text">Зона будет удалена.</p>
        )}

        {error && <p className="vio-field-error">{error}</p>}

        <div className="vio-modal-actions">
          <button type="button" className="vio-btn" disabled={busy} onClick={onCancel}>
            Отмена
          </button>
          <button type="button" className="vio-btn vio-btn--danger" disabled={busy} onClick={onConfirm}>
            {busy ? 'Удаляем…' : isDependency ? 'Удалить зону и деактивировать правила' : 'Удалить зону'}
          </button>
        </div>
      </div>
    </>
  );
};

export default ZoneDeleteConfirmModal;
